import ModuleSmartStream from '@vivotek/ssmux';
/*
 * Copyright (c) 2018 Vivotek Inc. All rights reserved.
 *
 * +-----------------------------------------------------------------+
 * | THIS SOFTWARE IS FURNISHED UNDER A LICENSE AND MAY ONLY BE USED |
 * | AND COPIED IN ACCORDANCE WITH THE TERMS AND CONDITIONS OF SUCH  |
 * | A LICENSE AND WITH THE INCLUSION OF THE THIS COPY RIGHT NOTICE. |
 * | THIS SOFTWARE OR ANY OTHER COPIES OF THIS SOFTWARE MAY NOT BE   |
 * | PROVIDED OR OTHERWISE MADE AVAILABLE TO ANY OTHER PERSON. THE   |
 * | OWNERSHIP AND TITLE OF THIS SOFTWARE IS NOT TRANSFERRED.        |
 * |                                                                 |
 * | THE INFORMATION IN THIS SOFTWARE IS SUBJECT TO CHANGE WITHOUT   |
 * | ANY PRIOR NOTICE AND SHOULD NOT BE CONSTRUED AS A COMMITMENT BY |
 * | VIVOTEK INC.                                                    |
 * +-----------------------------------------------------------------+
 *
 */

function Gouqi(params, done) {
  this.m_ctx = null;
  this.m_texture = 0;
  this.m_heatmap = 0;
  this.decodedFrameCnt = 0;
  this.module = new ModuleSmartStream();

  // ---------------------------------------------------------------------------------
  // handle input image source
  function initTexture(sFilename) {
    this.m_texture = this.m_ctx.createTexture();
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, this.m_texture);
    this.m_ctx.texImage2D(this.m_ctx.TEXTURE_2D, 0, this.m_ctx.RGBA, 1, 1, 0, this.m_ctx.RGBA,
      this.m_ctx.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 255]));
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, null);
  }

  function initHeatmapTexture(sFilename) {
    this.m_heatmap = this.m_ctx.createTexture();
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, this.m_heatmap);
    this.m_ctx.texImage2D(this.m_ctx.TEXTURE_2D, 0, this.m_ctx.RGBA, 1, 1, 0,
    this.m_ctx.RGBA, this.m_ctx.UNSIGNED_BYTE, new Uint8Array([0, 0, 0, 0]));
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, null);
  }

  function isPowerOfTwo(x) {
    // eslint-disable-next-line no-bitwise
    return (x & (x - 1)) === 0;
  }

  function handleLoadedTexture(texture) {
    try {
      this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, texture);

      this.m_ctx.texImage2D(this.m_ctx.TEXTURE_2D, 0, this.m_ctx.RGBA, this.m_ctx.RGBA, this.m_ctx.UNSIGNED_BYTE,
        texture.image);
      this.m_ctx.texParameteri(this.m_ctx.TEXTURE_2D, this.m_ctx.TEXTURE_WRAP_S, this.m_ctx.CLAMP_TO_EDGE);
      this.m_ctx.texParameteri(this.m_ctx.TEXTURE_2D, this.m_ctx.TEXTURE_WRAP_T, this.m_ctx.CLAMP_TO_EDGE);

      if (isPowerOfTwo(texture.image.width) && isPowerOfTwo(texture.image.height)) {
        this.m_ctx.texParameteri(this.m_ctx.TEXTURE_2D, this.m_ctx.TEXTURE_MAG_FILTER, this.m_ctx.NEAREST);
        this.m_ctx.texParameteri(this.m_ctx.TEXTURE_2D, this.m_ctx.TEXTURE_MIN_FILTER, this.m_ctx.NEAREST);
      } else {
        this.m_ctx.texParameteri(this.m_ctx.TEXTURE_2D, this.m_ctx.TEXTURE_MAG_FILTER, this.m_ctx.LINEAR);
        this.m_ctx.texParameteri(this.m_ctx.TEXTURE_2D, this.m_ctx.TEXTURE_MIN_FILTER, this.m_ctx.LINEAR);
      }

      this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, null);
    } catch (e) {
      // const log = document.getElementById('logger');
      // log.innerHTML = `${log.innerHTML}<BR>${e.message}`;
      console.log("handleLoadedTexture error: ", e.message);
    }
  }

  // eslint-disable-next-line no-unused-vars
  function setTextureImg(sFilename) {
    this.m_texture.image = sFilename;
    handleLoadedTexture.call(this, this.m_texture);
  }

  function setHeatmapImg(sFilename) {
    this.m_heatmap.image = sFilename;
    handleLoadedTexture.call(this, this.m_heatmap);
  }

  function isTextureUpdated(video) {
    return true;
    // var bUpdateTexture = false;
    // if (video.webkitDecodedFrameCount !== undefined) {
    //   // webkitDecodedFrameCount - number of frames that have been demuxed and extracted out of the media.
    //   if (this.decodedFrameCnt !== video.webkitDecodedFrameCount) {
    //     bUpdateTexture = true;
    //     this.decodedFrameCnt = video.webkitDecodedFrameCount;
    //   }
    // }
    // else if (video.mozDecodedFrames !== undefined) {
    //   // mozDecodedFrames - number of frames that have been decoded
    //   if (this.decodedFrameCnt !== video.mozDecodedFrames) {
    //     bUpdateTexture = true;
    //     this.decodedFrameCnt = video.mozDecodedFrames;
    //   }
    // }
    // else {
    //   bUpdateTexture = true;
    // }
    // return bUpdateTexture;
  }

  //---------------------------------------------------------------------------------
  Gouqi.prototype.setGL = (gl, canvas) => {
    this.m_ctx = gl;

    this.module.canvas = canvas;
    this.module.gouqi_initial(gl.viewportWidth, gl.viewportHeight);

    this.module.gouqi_setZoomROI(0, 0, 1, 1);

    // Warning: Don't use internal texture anymore. Users must set an input texture when rendering.
    initTexture.call(this);
    initHeatmapTexture.call(this);
  };

  Gouqi.prototype.release = (gl, canvas) => {
    this.module.gouqi_release();

    this.m_ctx.deleteTexture(this.m_texture);
    this.m_ctx.deleteTexture(this.m_heatmap);
  };

  Gouqi.prototype.setROI = (x, y, w, h) => {
    this.module.gouqi_setDisplaySize(w, h);
  };

  Gouqi.prototype.setZoomROI = (x, y, w, h) => {
    this.module.gouqi_setZoomROI(x, y, w, h);
  };

  Gouqi.prototype.addLine = (x0, y0, x1, y1) => {
    this.module.gouqi_line_add(x0, y0, x1, y1);
  };

  Gouqi.prototype.clearLines = () => {
    this.module.gouqi_line_clear();
  };

  // Render
  Gouqi.prototype.renderVideo = (video) => {
    if (video === undefined) {
      return;
    }

    let width = 0;
    let height = 0;
    if (video.tagName === 'IMG') {
      width = video.naturalWidth;
      height = video.naturalHeight;
    } else if (video.tagName === 'CANVAS') {
      width = video.width;
      height = video.height;
    } else {
      width = video.videoWidth;
      height = video.videoHeight;
    }

    if (width === 0 || height === 0) {
      return;
    }

    if (isTextureUpdated.call(this, video)) {
      setTextureImg.call(this, video);
    }

    this.m_ctx.activeTexture(this.m_ctx.TEXTURE0);
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, this.m_texture);

    this.module.gouqi_render();

    this.m_ctx.activeTexture(this.m_ctx.TEXTURE0);
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, null);
  };

  // Render
  Gouqi.prototype.renderVideoAndCover = (video, cover) => {
    if (video === undefined || cover === undefined) {
      return;
    }

    let width = 0;
    let height = 0;
    if (video.tagName === 'IMG') {
      width = video.naturalWidth;
      height = video.naturalHeight;
    } else if (video.tagName === 'CANVAS') {
      width = video.width;
      height = video.height;
    } else {
      width = video.videoWidth;
      height = video.videoHeight;
    }

    if (width === 0 || height === 0) {
      return;
    }

    if (isTextureUpdated.call(this, video)) {
      setTextureImg.call(this, video);
      setHeatmapImg.call(this, cover);
    }

    this.m_ctx.activeTexture(this.m_ctx.TEXTURE0);
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, this.m_texture);
    this.m_ctx.activeTexture(this.m_ctx.TEXTURE1);
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, this.m_heatmap);

    this.module.gouqi_renderWithCover();

    this.m_ctx.activeTexture(this.m_ctx.TEXTURE0);
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, null);
    this.m_ctx.activeTexture(this.m_ctx.TEXTURE1);
    this.m_ctx.bindTexture(this.m_ctx.TEXTURE_2D, null);
  };
  return this;
};


export default Gouqi;
